export default {
  QQ_CLIENT_ID: "101995894",
  QQ_REDIRECT_URL: "https://www.lict.club/callback/qq",
  GITEE_CLIENT_ID: "d029020a6839273e0e82d853783874bf1f4f34b95da6ebcbc230e6603ff9b656",
  GITEE_REDIRECT_URL: "https://www.lict.club/callback/gitee",
  WEIBO_CLIENT_ID: "2285022919",
  WEIBO_REDIRECT_URL: "https://www.lict.club/callback/weibo",
};
